import React, { useState, useContext } from "react";
import MeetingImage from "./MeetingImage";
import StatusSection from "./StatusSection";
import MeetingDetails from "./MeetingDetails";
import ActionButtons from "./ActionButtons";
import MeetingModal from "./MeetingModal";
import {
  formatISODateTime,
  unixStampToDate,
} from "../../../../../../common/utils";
import { getUserInfo } from "../../../../../../Store/User/accessors";
import { Context } from "../../../../../../Store";
import {
  MeetingOuterContainer,
  MeetingInnerContainer,
  Info,
  MeetingInformation,
  InfoRight,
  InfoDescription,
  InfoHeading,
  MeetingInfoInner,
} from "./style";
import { Description } from "../../ProgramParticipants/ProgramDashboard/styles";
import { formatDateForMeetingsUnixTimestamp } from "../../../../../../common/utils";
import moment from "moment-timezone";

const Meetings = ({
  openNetworkProgramsMeetings,
  params,
  navigate,
  // setIsDeleteModal,
  setSelectedMeeting,
  setShowForm,
  handleAddToCalender,
  handleCancelRequest,
  isUpcoming,
  isPast,
  reassignMentee,
  disableButtonId,
  isLoading,
  isConnection,
  isUnfulfilled,
  // isDeleteModal,
  isCancelRequest,
  setIsCancelRequest,
}) => {
  const { state } = useContext(Context);
  const [isCalenderDropdownActive, setIsCalenderDropdownActive] =
    useState(false);

  const meetingData =
    openNetworkProgramsMeetings?.data || openNetworkProgramsMeetings;

  // console.log("openNetworkProgramsMeetings:", openNetworkProgramsMeetings);

  return (
    <MeetingOuterContainer
      isUnfulfilled={isUnfulfilled}
      isHeight={true}
      isConnection={isConnection}
    >
      {meetingData?.map((item, i) => {
        const isMyMente = item?.Mentor?.id === item?.user?.id;
        const isMyMentor = item?.Mentor?.id !== item?.user?.id;
        const iamMentor = item?.Mentor?.id === getUserInfo(state).id;
        const programOneOnOne = item?.program?.programType === "1_1_NETWORK";
        const isNotMyMentor = item?.Mentor?.id !== item?.user?.id;

        const calcRemainingDaysHandler = (meetingScheduleTimestamp) => {
          const userTimeZone = moment.tz.guess();
          const currentDate = moment.tz(userTimeZone).startOf("day"); // normalize to midnight
          const meetingDate = moment
            .unix(meetingScheduleTimestamp)
            .tz(userTimeZone)
            .startOf("day");
          const remainingDays = meetingDate.diff(currentDate, "days");

          return remainingDays;
        };

        const remainingDays = calcRemainingDaysHandler(
          item?.meeting?.meetingScheduleDate
        );

        return (
          <MeetingInnerContainer
            isHeight={false}
            isConnection={isConnection}
            key={i}
          >
            <MeetingInformation>
              <MeetingInfoInner>
                <MeetingImage
                  item={item}
                  iamMentor={iamMentor}
                  programOneOnOne={programOneOnOne}
                  params={params}
                  isTeam={item?.program?.programType === "TEAM"}
                />
                <Info>
                  <StatusSection
                    isUnfulfilled={isUnfulfilled}
                    isConnection={isConnection}
                    item={item}
                    isMyMente={isMyMente}
                    isMyMentor={isMyMentor}
                    iamMentor={iamMentor}
                    programOneOnOne={programOneOnOne}
                    params={params}
                    isUpcoming={isUpcoming}
                  />
                  <MeetingDetails
                    item={item}
                    isTeam={item?.program?.programType === "TEAM"}
                    unixStampToDate={unixStampToDate}
                  />
                </Info>
              </MeetingInfoInner>

              {isUnfulfilled && (
                <InfoRight>
                  <InfoHeading>Requested On:</InfoHeading>
                  <InfoDescription>
                    {formatISODateTime(item?.meeting?.createdAt)}
                  </InfoDescription>
                </InfoRight>
              )}

              {!isUnfulfilled && (
                <>
                  {remainingDays >= 0 ? (
                    <p
                      style={{
                        height: "fit-content",
                        color: "#FF3030",
                        fontSize: "16px",
                        fontWeight: 500,
                        minWidth: "fit-content",
                      }}
                    >
                      {remainingDays === 0
                        ? "Meeting today"
                        : `Meeting in ${calcRemainingDaysHandler(
                            item?.meeting?.meetingScheduleDate
                          )} day${remainingDays > 1 ? "s" : ""}`}
                    </p>
                  ) : (
                    ""
                  )}
                </>
              )}
            </MeetingInformation>

            <ActionButtons
              item={item}
              navigate={navigate}
              iamMentor={iamMentor}
              handleAddToCalender={handleAddToCalender}
              setShowForm={setShowForm}
              // setIsDeleteModal={setIsDeleteModal}
              setSelectedMeeting={setSelectedMeeting}
              // selectedItemId={selectedItemId}
              isCalenderDropdownActive={isCalenderDropdownActive}
              setIsCalenderDropdownActive={setIsCalenderDropdownActive}
              // isDeleteRequest={isDeleteRequest}
              reassignMentee={reassignMentee}
              disableButtonId={disableButtonId}
              isLoading={isLoading}
              isUpcoming={isUpcoming}
              handleCancelRequest={() => handleCancelRequest(item)}
            />
            {/* {isDeleteModal && (
              <MeetingModal
                title="Are you sure you want to proceed?"
                onClose={() => {
                  setIsDeleteModal(false);
                }}
                isDelete={true}
                // deleteProgram={deleteProgram}
                deleteProgram={() => handleCancelRequest(item)}
              />
            )} */}
            {isCancelRequest && (
              <MeetingModal
                title="Are you sure you want to Cancel this Meeting?"
                onClose={() => setIsCancelRequest(false)}
              />
            )}
          </MeetingInnerContainer>
        );
      })}
    </MeetingOuterContainer>
  );
};

export default Meetings;
